import { c as _c } from "react/compiler-runtime";
import { PortableText } from "@portabletext/react";
import { Links } from "../../../main/blocks/Links/Links";
import styles from "./TaxDeductionsTab.module.scss";
export const TaxDeductionsTab: React.FC<{
  description: any[];
  links: any[];
}> = t0 => {
  const $ = _c(7);
  const {
    description,
    links
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <PortableText value={description} />;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== links) {
    t2 = <Links links={links} />;
    $[2] = links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.container}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};